// extracted by mini-css-extract-plugin
export default {"pageWrap":"Q-z","fullWidth":"R-z","heading":"S-z","fullBleed":"T-z","hidden":"U-z"};